import { axiosInstance } from "api";
import { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { AxiosConfig } from "type";

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig<AxiosConfig>) => {
    // Modify config headers, add authentication, etc.
    const token = null;
    const apiKey =
      import.meta.env.VITE_X_API_KEY ??
      (import.meta.env.VITE_X_API_KEY as string);
    config.headers = config.headers || {};
    if (token) {
      config.headers["x-access-token"] = `${token}`;
    }
    if (apiKey) {
      config.headers["x-api-key"] = `${apiKey}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      // The request was made and the server responded with a status code
      console.error("Response error:", error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Request error:", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);
